import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    student: '',
  },
}

export const rtiConcernReasonsUI = createSlice({
  name: 'rtiConcernReasonsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setStudent,
  trackActiveFilters,
  clearAllFilters,
} = rtiConcernReasonsUI.actions

export default rtiConcernReasonsUI.reducer
